import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import * as SecondaryNavActions from "./store/actions";
import useMediaQuery from "app/hooks/useMediaQuery";
import { animations } from "react-animation";
import "./SecondaryNavBar.css";

function SecondaryNavBar(props) {
  const [copyText, setCopyText] = useState("");
  const [linkedButtons, setLinkedButtons] = useState([]);
  const [logos, setLogos] = useState([]);
  const [showH1, setShowH1] = useState(false);
  const is4K = useMediaQuery("(min-width: 3840px)");
  const isFullHD = useMediaQuery("(min-width: 1920px)");
  const isMidLaptop = useMediaQuery("(min-width: 1366px)");
  const isIpadLandscape = useMediaQuery("(min-width: 1024px)");
  const isIpadPortrait = useMediaQuery("(min-width: 768px)");
  const isIphoneX = useMediaQuery("(min-width: 375px)");
  const isXSmall = useMediaQuery("(max-width: 374px)");

  const CREDITO_EN_LINEA_URL = "https://creditoenlinea.cs.fi.cr";

  const dispatch = useDispatch();
  let location = useLocation();

  useEffect(() => {
    !contentNavbar && dispatch(SecondaryNavActions.getSecondaryNavContent());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    location.pathname === "/" ? setShowH1(true) : setShowH1(false);
  }, [location]);

  const { contentNavbar } = useSelector(
    ({ SecondaryNavBar }) => SecondaryNavBar.SecondaryNavbar
  );

  useEffect(() => {
    if (contentNavbar) {
      setCopyText(contentNavbar?.aCBarraSecundariaCopyText);
      setLinkedButtons(
        contentNavbar?.aCBarraSecundariaBotonEnlaceBag[0]?.botonesEnlace
          ?.contentItems
      );
      setLogos(contentNavbar?.aCBarraSecundariaLogo);
    }
  }, [contentNavbar]);

  //Styles
  const contenedorStyle = () => {
    let cls = "";
    if (isXSmall) {
      cls = "d-flex flex-column";
    }
    if (isIphoneX) {
      cls = "d-flex flex-column";
    }
    if (isIpadPortrait) {
      cls = "d-flex justify-content-between";
    }
    if (isIpadLandscape) {
      cls = "d-flex justify-content-between";
    }
    if (isMidLaptop) {
      cls = "contenedordesktop d-flex justify-content-between";
    }
    if (isFullHD) {
      cls = "contenedordesktop d-flex justify-content-between";
    }
    if (is4K) {
      cls = "contenedor d-flex justify-content-between";
    }
    return cls;
  };

  const curSiteStyle = () => {
    let cls = "";
    if (isXSmall) {
      cls = "d-flex flex-column";
    }
    if (isIphoneX) {
      cls = "d-flex flex-column";
    }
    if (isIpadPortrait) {
      cls = "d-flex justify-content-between align-items-center";
    }
    if (isIpadLandscape) {
      cls = "d-flex justify-content-between align-items-center";
    }
    if (isMidLaptop) {
      cls = "d-flex justify-content-between align-items-center";
    }
    if (isFullHD) {
      cls = "d-flex justify-content-between align-items-center";
    }
    if (is4K) {
      cls = "d-flex justify-content-between align-items-center";
    }
    return cls;
  };

  const curLogoStyle = () => {
    let cls = "";
    if (isXSmall) {
      cls = "mx-auto curlogo";
    }
    if (isIphoneX) {
      cls = "mx-auto curlogo";
    }
    if (isIpadPortrait) {
      cls = "curlogo_ipad";
    }
    if (isIpadLandscape) {
      cls = "curlogo_ipad";
    }
    if (isMidLaptop) {
      cls = "curlogo";
    }
    if (isFullHD) {
      cls = "curlogo";
    }
    if (is4K) {
      cls = "curlogo";
    }
    return cls;
  };

  const sloganStyle = () => {
    let cls = "";
    if (isXSmall) {
      cls = "mx-auto slogan slogan_iphoneX";
    }
    if (isIphoneX) {
      cls = "mx-auto slogan slogan_iphoneX";
    }
    if (isIpadPortrait) {
      cls = "d-sm-none";
    }
    if (isIpadLandscape) {
      cls = "slogan slogan_ipad_landscape";
    }
    if (isMidLaptop) {
      cls = "slogan slogan_mid_laptop";
    }
    if (isFullHD) {
      cls = "slogan slogan_fullHD";
    }
    if (is4K) {
      cls = "slogan slogan_4K";
    }
    return cls;
  };

  const sloganStyleSmall = () => {
    let cls = "";
    if (isXSmall) {
      cls = "fs-6 d-none";
    }
    if (isIphoneX) {
      cls = "fs-6 d-none";
    }
    if (isIpadPortrait) {
      cls = "mx-auto mb-0 slogan slogan_ipad_portrait";
    }
    if (isIpadLandscape) {
      cls = "d-xs-none d-md-none d-lg-none";
    }
    if (isMidLaptop) {
      cls = "d-xs-none d-md-none d-lg-none";
    }
    if (isFullHD) {
      cls = "d-xs-none d-md-none d-lg-none";
    }
    if (is4K) {
      cls = "d-xs-none d-md-none d-lg-none";
    }
    return cls;
  };

  const optionLogosStyle = () => {
    let cls = "";
    if (isXSmall) {
      cls = "d-flex flex-wrap justify-content-center";
    }
    if (isIphoneX) {
      cls = "d-flex flex-wrap justify-content-center";
    }
    if (isIpadPortrait) {
      cls = "d-flex justify-content-between";
    }
    if (isIpadLandscape) {
      cls = "d-flex justify-content-between";
    }
    if (isMidLaptop) {
      cls = "d-flex justify-content-between";
    }
    if (isFullHD) {
      cls = "d-flex justify-content-between";
    }
    if (is4K) {
      cls = "d-flex justify-content-between";
    }
    return cls;
  };

  const optLogoStyle = () => {
    let cls = "";
    if (isXSmall) {
      cls = "optionlogo_mobile";
    }
    if (isIphoneX) {
      cls = "optionlogo_mobile";
    }
    if (isIpadPortrait) {
      cls = "optionlogo_mobile";
    }
    if (isIpadLandscape) {
      cls = "optionlogo_mobile";
    }
    if (isMidLaptop) {
      cls = "optionlogo_desktop";
    }
    if (isFullHD) {
      cls = "optionlogo_desktop";
    }
    if (is4K) {
      cls = "optionlogo_desktop";
    }
    return cls;
  };

  const creditContainerStyle = (isPrimary) => {
    let cls = "";
    if (isXSmall) {
      cls = isPrimary ? "container_credit_request pt-3" : "d-none";
    }
    if (isIphoneX) {
      cls = isPrimary ? "container_credit_request pt-3" : "d-none";
    }
    if (isIpadPortrait) {
      cls = isPrimary ? "d-none" : "container_credit_request pb-4";
    }
    if (isIpadLandscape) {
      cls = isPrimary ? "d-none" : "container_credit_request pb-4";
    }
    if (isMidLaptop) {
      cls = isPrimary ? "d-none" : "container_credit_request pb-4";
    }
    if (isFullHD) {
      cls = isPrimary ? "container_credit_request" : "d-none";
    }
    if (is4K) {
      cls = isPrimary ? "container_credit_request" : "d-none";
    }
    return cls;
  };

  const openLink = () => {
    window.open(CREDITO_EN_LINEA_URL,'_blank');
  };

  const renderCredidButton = (isPrimary) => {
    return (
      <div className={creditContainerStyle(isPrimary)}>
        <button className="button_credit_request" onClick={() => openLink()}>
          Solicita tu Crédito en Línea
        </button>
      </div>
    );
  };

  const iconsContainerStyle = () => {
    let _class = "";
    if (isIpadPortrait) {
      _class = "d-flex" ;
    } else {
      _class = "";
    }
    return _class;
  };

  const root = process.env.REACT_APP_CMS_STATIC;
  const items = (
    <>
      {linkedButtons.map((linkedButton, index) => (
        <a
          key={index}
          href={linkedButton.url.url}
          target="_blank"
          rel="noreferrer"
        >
          <img
            key={index}
            alt={linkedButton.textoalternativo}
            src={root + linkedButton.imagen.urls[0]}
            className={optLogoStyle()}
          />
        </a>
      ))}
    </>
  );

  return (
    <section
      id="secondaryNavigationBar"
      name="secondaryNavigationBar"
      className="maincontentwhite"
    >
      <div
        className={contenedorStyle()}
        style={{ animation: animations.fadeIn }}
      >
        <div className={curSiteStyle()}>
          {logos.length > 0 && (
            <a key="logo" href={logos[0].url.url}>
              <img
                alt={logos[0].textoalternativo}
                src={root + logos[0].imagen.urls[0]}
                className={curLogoStyle()}
              />
            </a>
          )}
          <div className={sloganStyle()}>
            {copyText && copyText[0].text.toUpperCase()}
          </div>
        </div>
        <div className={iconsContainerStyle()}>
          {renderCredidButton(true)}
          <div className={optionLogosStyle()}>
            {items}
          </div>
        </div>
      </div>
      <div className={sloganStyleSmall()}>
        {copyText && copyText[0].text.toUpperCase()}
      </div>
      {renderCredidButton(false)}
      {showH1 && (
        <h1 style={{ fontSize: "0", margin: "0" }}>Grupo CS Coopeservidores</h1>
      )}
    </section>
  );
}

export default SecondaryNavBar;
